import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IllustrationWarningSvg } from "./IllustrationWarningSvg.mjs";
const IllustrationWarning = () => /* @__PURE__ */ jsx(Box, { component: IllustrationWarningSvg });
export {
  IllustrationWarning
};
